(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBHeadendDeleteController',HeadendDeleteController);

    HeadendDeleteController.$inject = ['$uibModalInstance', 'entity', 'Headend'];

    function HeadendDeleteController($uibModalInstance, entity, Headend) {
        var vm = this;

        vm.headend = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Headend.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
